import { styled } from "@mui/material";
import Skeleton, { type SkeletonProps } from "@mui/material/Skeleton";

interface SabSkeletonProps extends SkeletonProps {
	maxWidth?: string | number;
	borderRadius?: string | number;
}

export const SabSkeleton = styled(Skeleton, {
	shouldForwardProp: (prop) => prop !== "maxWidth" && prop !== "borderRadius",
})<SabSkeletonProps>(({ theme, maxWidth, borderRadius }) => ({
	backgroundColor: theme.palette.deprecated.grey[100],
	maxWidth: maxWidth,
	borderRadius: borderRadius,
}));
